import { buildImgSrc, buildImgSrcSet } from '@/helpers/image-url'
import { ImageProps, Image as UdsImage } from '@sunwebgroup/uds-ui/image'

interface MediaServerImageProps extends ImageProps {
  widths: number[]
}

/**
 * Wrapper around the UDS Image component that provides a standardized way to render
 * responsive images from the media server. Accepts a `widths` array to automatically
 * generate a `srcSet`, keeping media server URL construction separate from UI concerns.
 */
export function MediaServerImage({ src, widths, ...props }: MediaServerImageProps) {
  return (
    <UdsImage
      src={buildImgSrc(src ?? '', Math.max(...widths))}
      srcSet={buildImgSrcSet(src ?? '', widths)}
      {...props}
    />
  )
}
